import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-up-new.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-down-new.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-3ca4a208")

_pushScopeId("data-v-3ca4a208")
const _hoisted_1 = { class: "flex flex-row items-center gap-x-2 mb-1" }
const _hoisted_2 = { class: "text-12px text-gray-lp-300 font-semibold" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-row items-center"
}
const _hoisted_4 = {
  key: 0,
  class: " text-gray-lp-600 text-16px bold mx-1"
}
const _hoisted_5 = { class: "text-12px" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "flex"
}
const _hoisted_8 = {
  key: 0,
  class: "flex items-center relative mr-2"
}
const _hoisted_9 = {
  key: 1,
  class: "text-16px text-gray-lp-300"
}
const _hoisted_10 = {
  key: 2,
  class: "flex"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_skeleton = _resolveComponent("skeleton")!
  const _component_detail_estimation = _resolveComponent("detail-estimation")!
  const _component_ModalErrorBalance = _resolveComponent("ModalErrorBalance")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", {
      id: _ctx.id,
      class: "flex flex-col py-1 px-2 rounded-lg bg-gray-lp-1000 border border-gray-lp-1400"
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("bookingShipment.estimation.totalCost")), 1),
        (
          _ctx.listDiscount.length &&
            !_ctx.isPosForClient &&
            !_ctx.adjustmentTariffRuleNonShow &&
            !_ctx.isClientForClient
        )
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listDiscount, (promo, index) => {
                return (_openBlock(), _createBlock("div", {
                  key: index,
                  class: ["flex items-center", { 'ml-2': index === 0 }]
                }, [
                  _createVNode("div", {
                    class: "flex flex-row bg-green-lp-700 text-white text-10px px-1 rounded-md mb-1 cursor-pointer",
                    onMouseenter: ($event: any) => (_ctx.onOpenTooltipPromo($event, index)),
                    onMouseleave: ($event: any) => (_ctx.onOpenTooltipPromo($event, index))
                  }, [
                    _createVNode("p", null, _toDisplayString(promo.promoConfigurationDiscountNominal) + "% Off", 1),
                    _createVNode(_component_Icons, {
                      name: "info",
                      class: "w-3 ml-1"
                    })
                  ], 40, ["onMouseenter", "onMouseleave"]),
                  (index !== _ctx.listDiscount.length - 1 && _ctx.listDiscount.length > 1)
                    ? (_openBlock(), _createBlock("span", _hoisted_4, "+"))
                    : _createCommentVNode("", true),
                  _createVNode(_component_OverlayPanel, {
                    ref: `infoPromo${index}`,
                    appendTo: "body",
                    class: "text-center",
                    style: {"width":"200px"}
                  }, {
                    default: _withId(() => [
                      _createVNode("p", _hoisted_5, _toDisplayString(promo.promoConfigurationName), 1)
                    ]),
                    _: 2
                  }, 1536)
                ], 2))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.showLoading)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode(_component_skeleton, {
              height: "1.25rem",
              width: "4.5rem"
            })
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_7, [
            (_ctx.formType === 'manual' && _ctx.dataProfile.account_type === 'partner')
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  (_openBlock(), _createBlock("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "20",
                    height: "20",
                    fill: "none",
                    viewBox: "0 0 20 20",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateEstimationPrice && _ctx.updateEstimationPrice(...args))),
                    class: "cursor-pointer"
                  }, [
                    _createVNode("path", {
                      fill: _ctx.showError ? '#B82025' : '#4D4D4D',
                      "fill-rule": "evenodd",
                      d: "M6.217 3.522c1.434-.837 3.105-1.175 4.751-.96 1.647.214 3.175.968 4.347 2.145 1.171 1.176 1.92 2.708 2.127 4.356.057.456-.266.873-.723.93-.457.058-.873-.266-.93-.722-.162-1.282-.744-2.473-1.655-3.388s-2.1-1.502-3.38-1.669c-1.281-.167-2.581.096-3.696.747-.737.43-1.366 1.014-1.847 1.706H7.5c.46 0 .833.373.833.833 0 .46-.373.833-.833.833H3.333c-.46 0-.833-.373-.833-.833V3.333c0-.46.373-.833.833-.833.46 0 .834.373.834.833v1.95c.567-.701 1.26-1.3 2.05-1.761zM3.28 10.007c.457-.058.874.265.932.722.162 1.28.744 2.471 1.655 3.386.912.914 2.1 1.501 3.38 1.668 1.28.166 2.58-.096 3.695-.747.737-.43 1.365-1.012 1.847-1.703H12.5c-.46 0-.833-.373-.833-.833 0-.46.373-.833.833-.833h4.167c.46 0 .833.373.833.833v4.167c0 .46-.373.833-.833.833-.46 0-.834-.373-.834-.833v-1.952c-.567.702-1.26 1.3-2.05 1.76-1.434.837-3.105 1.175-4.75.96-1.646-.214-3.175-.968-4.346-2.144-1.172-1.175-1.92-2.706-2.129-4.353-.058-.457.266-.874.722-.931z",
                      "clip-rule": "evenodd"
                    }, null, 8, ["fill"])
                  ]))
                ]))
              : _createCommentVNode("", true),
            (_ctx.showError)
              ? (_openBlock(), _createBlock("div", _hoisted_9, _toDisplayString(_ctx.$t("bookingV3.shipment.checkTariff.detail.error")), 1))
              : (_openBlock(), _createBlock("div", _hoisted_10, [
                  _createVNode("div", {
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showDetail && _ctx.showDetail(...args))),
                    class: "text-16px flex items-center cursor-pointer text-gray-lp-300 font-semibold"
                  }, _toDisplayString(_ctx.adjustmentTariffRuleNonShow
              ? "-"
              : _ctx.isPosForClient
              ? _ctx.prefixCurrency
              : _ctx.form.isCOD
              ? _ctx.formType === "client"
                ? _ctx.maskingTotalCost
                : _ctx.currency(_ctx.dataDetail.codAmount)
              : _ctx.isDiscountActive && !_ctx.isCODOnly
              ? _ctx.formType === "client"
                ? _ctx.maskingTotalCost
                : _ctx.currency(_ctx.dataDetail.totalTariffAfterDiscount)
              : _ctx.formType === "client"
              ? _ctx.maskingTotalCost
              : _ctx.currency(_ctx.bigLabelTotalTariff)), 1),
                  (
            _ctx.formType === 'manual' &&
              _ctx.dataProfile.account_type === 'partner' &&
              !_ctx.adjustmentTariffRuleNonShow
          )
                    ? (_openBlock(), _createBlock("button", {
                        key: 0,
                        class: "flex items-center ml-2",
                        onMousedown: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isMouseDown = true)),
                        onMouseup: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isMouseDown = false)),
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showDetail && _ctx.showDetail(...args))),
                        onFocus: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onFocusTrigger && _ctx.onFocusTrigger(...args))),
                        onBlur: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isShow = false)),
                        onKeydown: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onKeydownTrigger && _ctx.onKeydownTrigger(...args)))
                      }, [
                        _createVNode("img", {
                          alt: "up",
                          class: `cursor-pointer w-4 ${_ctx.isShow ? '' : 'hidden'}`,
                          src: _imports_0
                        }, null, 2),
                        _createVNode("img", {
                          alt: "down",
                          class: `cursor-pointer w-4 ${_ctx.isShow ? 'hidden' : ''}`,
                          src: _imports_1
                        }, null, 2)
                      ], 32))
                    : _createCommentVNode("", true),
                  _withDirectives(_createVNode("div", { class: "text-12px ml-1 text-gray-lp-600 line-through content-center" }, _toDisplayString(_ctx.currency(_ctx.bigLabelTotalTariff)), 513), [
                    [_vShow, 
            !_ctx.adjustmentTariffRuleNonShow &&
              _ctx.formType !== 'client' &&
              _ctx.bigLabelTotalTariff !== _ctx.dataDetail.totalTariffAfterDiscount &&
              _ctx.estimationPrice.listDiscount.length
          ]
                  ])
                ]))
          ]))
    ], 8, ["id"]), [
      [_directive_click_outside, () => _ctx.onCloseAnywhere(false)]
    ]),
    _createVNode(_component_detail_estimation, {
      class: "rounded-lg top-parent z-10",
      isShow: _ctx.isShow,
      dataDetail: _ctx.dataDetail,
      isDiscountActive: _ctx.isDiscountActive,
      isCodRetail: _ctx.isCodRetail,
      isForeignCurrency: !_ctx.accountIsNonForeign || _ctx.isEditSttMY,
      goodsValue: _ctx.goodsValue,
      isCOD: _ctx.form.isCOD,
      isDFOD: _ctx.form.isDFOD,
      listDiscount: _ctx.estimationPrice.listDiscount
    }, null, 8, ["isShow", "dataDetail", "isDiscountActive", "isCodRetail", "isForeignCurrency", "goodsValue", "isCOD", "isDFOD", "listDiscount"]),
    _createVNode(_component_ModalErrorBalance, {
      modelValue: _ctx.balanceUnderLimit,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.balanceUnderLimit = $event))
    }, null, 8, ["modelValue"])
  ], 64))
})